/** MUI v6 theme — Ops Console. */
import { createTheme } from '@mui/material/styles';
// Register the MuiDataGrid component key on the theme type.
import type {} from '@mui/x-data-grid-pro/themeAugmentation';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0a1a3f' }, // deep navy — clearly distinct from the tenant dashboard's #007AFF
    secondary: { main: '#fa3f33' },
    background: { default: '#f6f7fb', paper: '#ffffff' },
  },
  shape: { borderRadius: 8 },
  typography: {
    // "Inter Variable" is self-hosted via @fontsource-variable/inter (imported
    // in main.tsx); the rest is the system fallback stack.
    fontFamily:
      '"Inter Variable", "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0a1a3f',
          color: '#ffffff',
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { borderRadius: 8 } } },
    // A photo-less avatar shows an initial. MUI's default (white on grey[400]) is
    // 1.8:1 — navy with white is the console's own pairing and well past 4.5:1.
    MuiAvatar: { styleOverrides: { colorDefault: { backgroundColor: '#0a1a3f', color: '#ffffff' } } },
    MuiDataGrid: {
      // Ops daily-driver: compact rows (~36px vs 52px) on every grid.
      defaultProps: { density: 'compact' },
      // Fixed-width digits so ID/date/count columns align down the page.
      styleOverrides: { root: { fontVariantNumeric: 'tabular-nums' } },
    },
  },
});
